<span class="dialog-close" mat-dialog-close>
  <mat-icon>close</mat-icon>
</span>
<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content class="flex flex-col">
  <p class="pl-4">{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button (click)="onConfirm()" color="primary">{{button}}</button>
  <button mat-flat-button (click)="onDismiss()" color="primary">Abbrechen</button>
</mat-dialog-actions>
